<div class="attachment-type-list-content">
  <div *ngIf="formatedGroupList.length || loading; else noGroupList">
    <app-table
      [items]="formatedGroupList"
      [loading]="loading"
      [deleteTitle]="tk.Management.AttachmentTypeTitleDeleteConfirmation | t"
      [headers]="headers"
      [columns]="columns"
      [permissions]="attachmentTypePermissions"
      [totalRecords]="pagination.total"
      [rows]="pagination.itemsPerPage || 5"
      (sendTablePagination)="handleTablePagination($event)"
      (sendTableAction)="handleTableAction($event)"
      (sendTableSelection)="handleTableSelection($event)">
    </app-table>
  </div>
  <ng-template #noGroupList>
    <div class="attachment-type-list-content__empty">
      <h4>{{ tk.Management.NoAttachmentTypesRegistered | t }}</h4>

      <div
        class="attachment-type-list-content__empty__button"
        *appHasPermission="attachmentTypePermissions.CREATE">
        <app-button
          [id]="'add-attachment-type'"
          [label]="tk.User.ToAdd | t"
          [icon]="'pi pi-plus'"
          [type]="'button'"
          (sendButtonClick)="addAttachmentType()"></app-button>
      </div>
    </div>
  </ng-template>
</div>
